<template>
  <div class="full-size">
    <hi-row title-bar text-center>Send Test</hi-row>
    <hi-row py-md text-center>
      <v-text-field v-model="testName" placeholder="Name" solo flat dense>
      </v-text-field>
      <v-text-field
        placeholder="Mobile Number *"
        :rules="mobileValidator"
        v-model="testMobile"
        solo
        flat
        dense
      >
      </v-text-field>
      <hi-clickable @click="sendTest" ref="sendTestBtn">Send</hi-clickable>
    </hi-row>
    <hi-row title-bar text-center>Select Recipients & Schedule Campaign</hi-row>
    <hi-row py-md separator color="white" text-center class="ui-text">
      Selected {{ selectedProjects.length }} project(s) with total
      <span class="bold"> {{ totalLeads }}</span> leads
      <div>Estimated cost: ${{ estimatedCost }} USD</div>
    </hi-row>

    <hi-row grow :px="0">
      <hi-list :items="projects" multiple v-model="selectedProjects">
        <template v-slot="{ item }">
          <v-list-item-content>
            <v-list-item-title
              ><h3>{{ item }}</h3></v-list-item-title
            >
            <v-list-item-subtitle class="ui-text-italic">
              Leads with mobile phone:
              {{ leadsByProject[item].length }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </hi-list>
    </hi-row>
  </div>
</template>

<script>
import HiClickable from "@/components/HiClickable";
import Validator from "@/hive/Validator";
import Formatter from "@/hive/Formatter";
import { api } from "@/api";
import { db } from "@/db";
import HiRow from "@/components/scaffold/HiRow";
import HiList from "@/components/HiList";
export default {
  name: "SmsSender",
  components: { HiList, HiRow, HiClickable },
  props: {
    smsText: {
      type: String
    }
  },
  data() {
    return {
      mobileValidator: [
        v => !v || Validator.mobile(v) || "Mobile number must be valid."
      ],
      testMobile: null,
      testName: null,
      leads: null,
      selectedProjects: []
      // leadsByProject:{}
    };
  },
  firestore: {
    leads: db.collection("leads").where("mobile", "!=", null)
  },
  methods: {
    async sendTest() {
      console.log(this.smsText);
      console.log(Formatter.mobileE164(this.testMobile));

      try {
        const result = await api.sms.sendMessage(this.text, {
          name: this.testName,
          number: Formatter.mobileE164(this.testMobile)
        });
        console.log(result);
      } catch (e) {
        console.log(e);
      } finally {
        //todo enable function has been deleted
        this.$refs.sendTestBtn.enable();
      }
    }
  },
  mounted() {
    console.log(this.leads);
  },
  computed: {
    leadsByProject() {
      if (this.leads && this.leads.length) {
        const dict = {};
        for (let i = 0; i < this.leads.length; i++) {
          const lead = this.leads[i];
          const projects = lead.projects;
          for (let p = 0; p < projects.length; p++) {
            const project = projects[p];
            if (!dict[project]) {
              dict[project] = [];
            }
            dict[project].push(lead);
          }
        }
        console.log(dict);
        return dict;
      } else {
        return null;
      }
    },
    projects() {
      console.log(this.leadsByProject);
      const keys = [];
      for (let key in this.leadsByProject) {
        keys.push(key);
      }
      return keys;
      // return [];
      // if (!this.leadsByProject) return null;
      // return this.leadsByProject.keys();
    },
    summary() {
      return this.selectedProjects.length;
    },
    totalLeads() {
      let count = 0;
      for (let i = 0; i < this.selectedProjects.length; i++) {
        const index = this.selectedProjects[i];
        const project = this.projects[index];
        count += this.leadsByProject[project].length;
      }
      return count;
    },
    estimatedCost() {
      // console.log(this.smsText);
      const segments = this.smsText ? Math.ceil(this.smsText.length / 153) : 1;
      console.log(segments);
      return Math.ceil(this.totalLeads * segments * 0.75) / 100;
    },
    projectsValue() {
      const arr = [];
      for (let i = 0; i < this.selectedProjects.length; i++) {
        const index = this.selectedProjects[i];
        const project = this.projects[index];
        arr.push(project);
      }
      return arr;
    }
  }
};
</script>

<style scoped></style>
